<template>
  <form @submit.prevent="action.search" method="post" class="header-search">
    <div class="header-search-title">ご利用ガイド</div>
    <div class="header-search-input">
      <div class="formparts search mb0" style="display: block;">
        <FontawesomeIcon @click="action.search" :icon="['far','search']" size="2x" class="icn" />
        <input type="text" maxlength="50" placeholder="キーワードを入力（最大50文字）"
          v-model="state.keyword" 
          @input="suggest.keyInput" 
          @compositionend="suggest.keyInput" 
          @blur="suggest.displayTip = false">
        <div v-if="suggest.fixedCount && suggest.displayTip" class="tip">{{suggest.fixedCount}}</div>
      </div>
    </div>
  </form>
</template>
<script>
import { defineComponent } from '@vue/composition-api'
import { GuideSearch} from '@/logic/guide/GuideSearch'

export default defineComponent({
  name: 'PCGuideSearch',
  components: {
  },
  setup (props, context) {
    return { ...GuideSearch(props, context) }
  }
})
</script>

<style lang="scss" scoped>
</style>
